interface Strings {
  ariaLabel?: string,
}

export class StatusBarProgressConfig {
  public static defaultStrings: Strings = {}
}
